export default __webpack_public_path__ + "static/media/plus-button.07f06767.png";